import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Row, Col, Icon } from 'antd'
import imgBottomLogo from 'assets/image/footer-logo@3x.png'
import imgBg from 'assets/image/bg.png'

class Home extends Component {
  startExam = () => {
    this.props.history.push('/exam')
  }

  render() {
    return (
      <Row style={{ backgroundImage: `url(${window.sspaiStaticRoot + imgBg})`, backgroundSize: 'cover' }}>
        <Col>
          <Row style={{ width: 180, height: '100vh', paddingTop: 120, margin: '0 auto' }}>
            <Col>
              <Row>
                <Col
                  style={{
                    backgroundImage: 'linear-gradient(to right, #ffdbdb, #292c3c)',
                    fontSize: 52,
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: '3.6px',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  测一测
                </Col>
              </Row>

              <Row>
                <Col
                  style={{
                    backgroundImage: 'linear-gradient(to right, #a18a91, #2b2e41 93%)',
                    fontSize: 36,
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: '2.7px',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  你的
                </Col>
              </Row>

              <Row>
                <Col
                  style={{
                    backgroundImage: 'linear-gradient(to right, #ff0042, #ee90a8 100%, #ffe4eb)',
                    fontSize: 52,
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: '3.6px',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  少数派
                </Col>
              </Row>

              <Row>
                <Col
                  style={{
                    backgroundImage: 'linear-gradient(to right, #a18a91, #2b2e41 93%)',
                    fontSize: 36,
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: '2.7px',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  指数
                </Col>
              </Row>

              <Row>
                <Col style={{ marginTop: 70 }}>
                  <div
                    style={{
                      height: 60,
                      width: '100%',
                      border: '2px solid #e41048',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#e41048',
                      fontSize: 24,
                      fontWeight: 600,
                      userSelect: 'none',
                    }}
                    onClick={this.startExam}
                  >
                    开始测试
                    <Icon style={{ marginLeft: 6 }} type='arrow-right' />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col style={{ marginTop: 50 }}>
                  <img style={{ width: 130 }} src={imgBottomLogo} alt='logo' />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default withRouter(Home)
